<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学导跟进数据</Breadcrumb-item>
        <Breadcrumb-item>课程消耗数据</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="6">
          <Form-item label="课程顾问昵称" :label-width="85">
            <Input placeholder="支持模糊搜索" name="adviserNickname"
                   v-model="queryParam.adviserNickname"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="学生ID" >
            <Input name="uid" v-model="queryParam.uid"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
          <Form-item label="学生昵称" >
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.userNickname"></Input>
          </Form-item>
          </Col>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="老师ID" >
            <Input name="tchId" v-model="queryParam.tchId"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item :label-width="75" label="老师姓名">
            <Input placeholder="支持模糊搜索" name="tchName"
                   v-model="queryParam.tchName"></Input>
          </Form-item>
          </Col>
        </Row>
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="审核状态">
            <Select v-model.number="queryParam.checkStatus" placeholder="全部"
                    @on-change="search" clearable>
              <Option v-for="item in $constant.bookLessonOpenedCheckStatus"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="学生是否投诉" :label-width="85">
            <Select v-model="queryParam.userIsComplaint" placeholder="全部"
                    @on-change="search" clearable>
              <Option value="1">是</Option>
              <Option value="2">否</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
          <Form-item label="老师是否评价" :label-width="85">
            <Select v-model="queryParam.tchIsFeedback" placeholder="全部"
                    @on-change="search" clearable>
              <Option value="1">是</Option>
              <Option value="0">否</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookLesson/finished/list"
          :params="queryParam" :onLoading="onLoading" class="finished-list"></List>
    <BookUserFeedbackModal :openedId="openedId" v-model="showBookUserFeedbackModal"></BookUserFeedbackModal>
    <BookTchFeedbackModal :openedId="openedId" v-model="showBookTchFeedbackModal"></BookTchFeedbackModal>
    <ClassMemberTimeModal :openedId="openedId" v-model="showClassMemberTimeModal"></ClassMemberTimeModal>
    <MonitorLessonRecordListModal :openedId="openedId"
                                  v-model="showMonitorLessonRecordListModal"></MonitorLessonRecordListModal>
    <BookTchScoreFeedbackModal :openedId="openedId" v-model="showBookTchScoreFeedbackModal"></BookTchScoreFeedbackModal>
  </div>
</template>
<style>
  .ivu-table .ivu-rate {
    font-size: 16px;
  }
  .ivu-table .ivu-rate-star {
    margin-left: 1px;
    margin-right: 1px;
  }
  .finished-list .ivu-table-cell {
    padding-left: 8px;
    padding-right: 8px;
  }
</style>
<script>
  import BookUserFeedbackModal from '../lesson/BookUserFeedbackModal.vue'
  import BookTchFeedbackModal from '../lesson/BookTchFeedbackModal.vue'
  import ClassMemberTimeModal from '../lesson/ClassMemberTimeModal.vue'
  import MonitorLessonRecordListModal from '../lesson/modal/MonitorLessonRecordListModal.vue'
  import BookTchScoreFeedbackModal from '../lesson/BookTchScoreFeedbackModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
  export default {
    components: {
      BookUserFeedbackModal,
      BookTchFeedbackModal,
      ClassMemberTimeModal,
      MonitorLessonRecordListModal,
      BookTchScoreFeedbackModal,
    },
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        searchLoading: false,
        reload: 0,
        rankScoreSeq: 0,
        queryParam: {
          tchId: '',
          tchName: '',
          tchEmail: '',
          uid: '',
          userMobile: '',
          userNickname: '',
          adviserNickname: '',
          studyAdviserNickname: '',
          tchCategory: '',
          lsnSelStatus: '',
          lsnType: '',
          courseType: '',
          checkStatus: '',
          startTimeDate: '',
          endTimeDate: '',
          startTime: '',
          endTime: '',
          studyAdviserId: ''
        },
        openedId: null,
        showBalanceModal: false,
        showRejectBalanceModal: false,
        showBookUserFeedbackModal: false,
        showClassMemberTimeModal: false,
        showBookTchFeedbackModal: false,
        showBookTchScoreFeedbackModal: false,
        showMonitorLessonRecordListModal: false,
        monitorLessonRecordId: null,
        tchStudyAdviserList: [],
        title: [
          {
            title: '学生ID、姓名',
            width: 90,
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('span', row.uid + '-'),
                h('span', row.userNickname),
              ])
            }
          },
          {
            title: '老师姓名',
            width: 140,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: (row.tchFirstName || '') + (row.tchLastName || ''),
                score: row.monthRankScore
              })
            }
          },
          {
            title: '学顾',
            width: 70,
            key: 'studyAdviserNickname'
          },
          {
            title: '课程名称',
            width: 70,
            key: 'lessonTitle'
          },
          {
            title: '上课类型',
            align: 'center',
            width: 70,
            render: (h, params) => {
              let courseType = params.row.courseType
              let typeEnum = $constant.getEnum($constant.courseType, courseType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程顾问',
            width: 70,
            key: 'adviserNickname'
          },
          {
            title: '外教运营',
            width: 70,
            key: 'tchAdviserNickname'
          },
          {
            title: '上课时间',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '上课时长',
            align: 'center',
            width: 60,
            key: 'courseTime'
          },
          {
            title: '学生对老师评价',
            width: 80,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let bookUserFeedbackId = row.bookUserFeedbackId
              let bookUserFeedbackStar = row.bookUserFeedbackStar
              if (bookUserFeedbackId) {
                return h('div', [
                  h('Rate', {
                    props: {
                      disabled: true,
                      count: bookUserFeedbackStar,
                      value: bookUserFeedbackStar
                    }
                  }),
                  h('br'),
                  h('a', {on: {
                    click: () => {
                      this.openedId = row.id
                      this.showBookUserFeedbackModal = true
                    }
                  }}, '查看')
                ])
              }
              return h('span', { style: { color: 'red' } }, '未评论')
            }
          },
          {
            title: '老师对学生评价',
            width: 80,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let bookTchFeedbackUid = row.bookTchFeedbackUid
              if (bookTchFeedbackUid) {
                return h('a', {on: {
                  click: () => {
                    this.openedId = row.id
                    if (row.lsnType === 1) {
                      this.showBookTchScoreFeedbackModal = true
                    } else {
                      this.showBookTchFeedbackModal = true
                    }
                  }
                }}, '查看')
              }
              return h('span', { style: { color: 'red' } }, '未评论')
            }
          },
          {
            title: '上课情况',
            width: 70,
            align: 'center',
            render: (h, params) => {
              return h('a', {on: {
                click: () => {
                  this.openedId = params.row.id
                  this.showClassMemberTimeModal = true
                }
              }}, '查看')
            }
          },
          {
            title: '教室',
            width: 70,
            render: (h, params) => {
              let row = params.row
              let classType = row.classType
              let typeEnum = $constant.getEnum($constant.classType, classType)
              return h('div', [
                h('span', typeEnum && typeEnum.text),
                h('span', ' - '),
                h('span', row.courseId)
              ])
            }
          },
          {
            title: '监课记录',
            width: 70,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let isMonitorLessonRecord = row.isMonitorLessonRecord
              if (isMonitorLessonRecord) {
                return h('a', {on: {
                  click: () => {
                    this.openedId = row.id
                    this.showMonitorLessonRecordListModal = true
                  }
                }}, '查看')
              }
              return h('span', { style: { color: 'red' } }, '未记录')
            }
          },
          {
            title: '审核状态',
            width: 85,
            align: 'center',
            render: (h, params) => {
              let checkStatus = params.row.checkStatus
              let statusEnum = $constant.getEnum($constant.bookLessonOpenedCheckStatus, checkStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '审核备注',
            width: 120,
            key: 'checkReason'
          },
        ]
      }
    },
    mounted: function () {
      let self = this
      let queryParam = this.queryParam
      queryParam.uid = this.$route.query.uid
      this.$http.post('/adminUser/listByCondition', {adminGroupId: 7}).then(function (res) {
        self.tchStudyAdviserList = res.data
      })
    },
    created: function () {
      this.queryParam.studyAdviserId = localStorage.studyAdviserId
      this.queryParam.startTime = localStorage.startTime
      this.queryParam.endTime = localStorage.endTime
      this.queryParam.courseType = localStorage.courseType
      this.queryParam.lsnType = localStorage.lsnType
      console.log(this.queryParam)
    },
    methods: {
      onDateChange () {},
      search () {
        this.reload = new Date().getTime()
      },
            onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },
      startTimeDateChange (value) {
        this.queryParam.startTime = Date.parse(new Date(value)) / 1000
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = Date.parse(new Date(value)) / 1000
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ShowLessonCount.vue?06b3ac70